








































































import PartBank from "@/modules/cashPoint/models/PartBank";
import { PageChangeEvent } from "@progress/kendo-vue-dropdowns/dist/npm/common/events";
import { GridRowProps } from "@progress/kendo-vue-grid";
import Vue from "vue";

interface Data {
  skip: number;
  take: number;
  bankAccountDialog: boolean;
  filterText: string;
  selectedName: string;
}

interface Props {
  disabled: boolean;
  addNew: boolean;
  labelmd: string;
  showLabel: boolean;
  partBanks: PartBank[];
  selectedBankAccount: PartBank | undefined;
  extraClass: string;
  labelCol: string;
  itemCol: string;
}

export default Vue.extend<Data, {}, {}, Props>({
  props: {
    disabled: { type: Boolean, default: false },
    addNew: { type: Boolean, default: false },
    labelmd: { type: String, default: "2" },
    showLabel: { type: Boolean, default: true },
    partBanks: Array as () => PartBank[],
    selectedBankAccount: Object as () => PartBank,
    extraClass: { type: String, default: "" },
    labelCol: { type: String, default: "4" },
    itemCol: { type: String, default: "8" },
  },

  data: () => ({
    skip: 0,
    take: 10,
    bankAccountDialog: false,
    filterText: '',
    selectedName: '- | - | -',
  }),

  methods: {
    itemSelected(props: GridRowProps) {
      const partBank = props.dataItem;
      this.bankAccountDialog = false;
      this.$emit("change", partBank);
    },

    pageChange(event: PageChangeEvent) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },

    textChanged(){
      this.filterText = this.selectedName;
    },

    dialogChanged() {
      if (!this.bankAccountDialog) {
        this.filterText = '';
      }

      this.bankAccountDialog = !this.bankAccountDialog;
    },
  },

  computed: {
    items() {
      let items = this.partBanks;
      items = items.filter(x => (x.accountNoSplit?.includes(this.filterText.toUpperCase()) ?? false) || (x.accountNo?.includes(this.filterText.toUpperCase()) ?? false) || (x.bank?.includes(this.filterText.toUpperCase()) ?? false) || (x.currency?.includes(this.filterText.toUpperCase()) ?? false));

      return items.slice(this.skip, this.take + this.skip).map((x) => ({
        ...x,
        selected: x.id === this.selectedBankAccount?.id,
      }));
    },

    total() {
      return this.partBanks ? this.partBanks.length : 0;
    },
  },

  watch: {
    selectedBankAccount() {
      this.selectedName = ((this.selectedBankAccount?.accountNoSplit || this.selectedBankAccount?.accountNo || "-") +
        " | " + //
        (this.selectedBankAccount?.bank || "-") +
        " | " + //
        (this.selectedBankAccount?.currency || "-") //
      );
    }
  },
});
